import { Pipe, PipeTransform } from '@angular/core';
import { SituationFamiliale } from '../../models/situationFamiliale';

@Pipe({
	name: 'filterSituationFamilialeByName'
})
export class FilterSituationFamilialeByNamePipe implements PipeTransform {
	transform(situationFamiliale: SituationFamiliale[], filter: string): SituationFamiliale[] {
		if (
			!situationFamiliale ||
			!filter ||
			situationFamiliale === null ||
			filter === null ||
			filter === ''
		) {
			return situationFamiliale;
		}

		return situationFamiliale.filter((situationFamiliale: SituationFamiliale) => {
			if (situationFamiliale.name) {
				// TODO: add lastName too
				return situationFamiliale.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
